import React, {useEffect} from 'react';
import useInView from "./utils/useInView";
import {useGetServices, useServices} from "./stores/otherStore";

const Services = () => {
    const [ref, inView] = useInView();
    const services = useServices();
    const getServices = useGetServices();
    useEffect(() => {
        void getServices();
    }, [getServices]);

    return (
        <div
            ref={ref}
            className={`opacity-0 scale-90 transition-all duration-500 
        ${inView ? "animate-fadeIn" : ""}`}
        >
            <div className="flex flex-wrap container justify-center px-5 py-16">
                <h2 className='md:text-4xl text-xl font-bold mb-8 text-center'>«AyarGroup» предоставляет своим
                    клиентам следующие услуги:</h2>
                <div className='flex flex-wrap justify-center gap-10 gap-y-10 w-3/4 md:gap-5 lg:gap-x-0 lg:gap-y-10 md:gap-y-14'>
                    {services.map((ser, index) => {
                        return (
                            <div className='flex flex-col justify-center items-center w-1/3' key={index}>
                                <img className='w-[70px] h-[70px] mb-5' src={ser.image} alt={ser.name}/>
                                <h5 className='font-semibold md:text-xl lg:text-2xl h-10 text-[#000] mb-3 text-center'>{ser.name}</h5>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    );
};

export default Services;